import { Bar } from "react-chartjs-2";
import ChartContainer from './chartContainer';

const SummaryOfHoursBarChart = ({title, data}) => {
    const labels = data.map(item => item.name);
    const chartData = {
        labels: labels,
        datasets: data.map(item => ({
          data: [item],
          label: item.name,
          maxBarThickness: 20,
          stack: 'bar',
          parsing: {
            yAxisKey: 'name',
            xAxisKey: 'value',
        }}))
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
            x: {
                title: 'Summary of Hours By Description',
                beginAtZero: true,
                suggestedMin: 0,
                suggestedMax: 1,
                ticks: {
                    autoSkip: false,
                    precision: 0,
                }
            },
            y: {
                grid: {
                    drawOnChartArea: false,
                },
            },
        },
        plugins: {
            title: {
                display: true,
                position: 'top',
                color: 'black',
                text: 'Summary of Hours By Description',
                font: {
                    size: 20,
                    family: "work-Sans, sans-serif",
                }
            },
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: (Item) => `${Item.label}: ${Item.formattedValue}`,
                }
            },
        },
    }

    return (
        <ChartContainer>
            <Bar data={chartData} options={options}/>
        </ChartContainer>
    )
}

export default SummaryOfHoursBarChart;